/**
 * Input CSS styles for the survey widget.
 * Includes custom radio buttons, checkboxes, text inputs, textareas,
 * and length hints. Uses BEM naming with ph- prefix.
 */
export const inputsCSS = `
    /* ===== Custom radio button ===== */
    .ph-input--radio {
        position: relative;
        appearance: none;
        width: 18px;
        height: 18px;
        border: 2px solid;
        border-color: var(--ph-text-color-32);
        border-radius: 50%;
        cursor: pointer;
    }

    .ph-input--radio:focus-visible {
        outline: 2px solid var(--ph-element-color);
        outline-offset: 2px;
    }

    .ph-input--radio:checked::after {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        width: 8px;
        height: 8px;
        background-color: var(--ph-element-color);
        border-radius: 50%;
        transform: translate(-50%, -50%);
    }

    .ph-input--radio:checked {
        border-color: var(--ph-element-color);
    }

    /* ===== Custom checkbox ===== */
    .ph-input--checkbox {
        appearance: none;
        -webkit-appearance: none;
        width: 18px;
        height: 18px;
        border: 2px solid var(--ph-element-color);
        border-radius: 4px;
        background-color: transparent;
        cursor: pointer;
        position: relative;
        flex-shrink: 0;
    }

    .ph-input--checkbox:checked::after {
        content: '';
        position: absolute;
        left: 4px;
        top: 0px;
        width: 5px;
        height: 9px;
        border: solid var(--ph-element-color);
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
    }

    /* ===== Native radio ===== */
    input[type="radio"] {
        accent-color: var(--ph-element-color);
        width: 18px;
        height: 18px;
        color: var(--ph-text-color-32);
        margin: 0px;
        padding: 0px;
    }

    input[type="radio"]:hover {
        cursor: pointer;
    }

    input[type="radio"]:checked ~ .ph-option {
        border: 1px solid var(--ph-element-color);
    }

    /* ===== Native checkbox ===== */
    input[type="checkbox"]:hover {
        cursor: pointer;
    }

    input[type="checkbox"]:checked ~ .ph-option {
        border: 1px solid var(--ph-element-color);
    }

    /* ===== Text input focus ===== */
    input[type="text"]:focus {
        outline: solid 2px var(--ph-element-color);
        border: solid 1px var(--ph-element-color);
    }

    /* ===== Custom text input (inline) ===== */
    .ph-input--text-inline {
        border: none !important;
    }

    .ph-input--text-inline:focus-visible {
        outline: 2px solid var(--ph-element-color);
        outline-offset: 2px;
    }

    .ph-input--text-inline:placeholder-shown {
        color: var(--ph-text-color-08) !important;
    }

    /* ===== Email input and textarea ===== */
    .ph-input--email,
    textarea {
        width: 100%;
        padding: 16px 12px;
        border: 1px solid;
        border-color: var(--ph-text-color-32);
        border-radius: 4px;
        font-size: 16px;
        font-weight: 400;
        word-wrap: break-word;
        white-space: pre-line;
        font-family: var(--ph-font-family);
        box-sizing: border-box;
        background-color: transparent;
        color: var(--ph-text-color);
    }

    .ph-input--email::placeholder,
    textarea::placeholder {
        color: var(--ph-text-color-32);
        font-size: 16px;
        font-style: normal;
        font-family: var(--ph-font-family);
        line-height: normal;
        padding: 0;
        margin: 0;
    }

    .ph-input--email:focus,
    textarea:focus {
        outline: solid 2px var(--ph-element-color);
        border: solid 1px var(--ph-element-color);
    }

    /* ===== Short text ===== */
    .ph-input--short {
        height: 20px;
    }

    /* ===== Long text ===== */
    .ph-input--long {
        height: 50px;
    }

    /* ===== Answer option label (flex fill) ===== */
    .ph-option label {
        flex: 1;
    }

    /* ===== Length hint ===== */
    .ph-length-hint {
        font-size: var(--ph-font-tiny);
        position: absolute;
        right: 12px;
        margin-top: -20px;
        color: var(--ph-text-color-50);
    }
`;
